var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.585 1.939c-.576.06-.992.553-.93 1.102l2.043 17.894c.063.55.58.946 1.156.886l4.171-.432c.576-.06.992-.554.93-1.103L20.911 2.392c-.063-.55-.58-.946-1.156-.886l-4.171.433Zm3.355 1.663a.519.519 0 0 1 .578.443l.546 4.78a.506.506 0 0 1-.465.55l-2.086.217a.52.52 0 0 1-.578-.443l-.545-4.78a.506.506 0 0 1 .465-.55l2.085-.217Zm2.223 14.858a.52.52 0 0 0-.578-.443l-2.085.217a.506.506 0 0 0-.465.55.52.52 0 0 0 .578.444l2.086-.217a.506.506 0 0 0 .464-.55ZM1.5 3c0-.552.47-1 1.049-1h4.195c.58 0 1.05.448 1.05 1v18c0 .552-.47 1-1.05 1H2.55c-.58 0-1.049-.448-1.049-1V3Zm4.577 1.5c0-.276-.235-.5-.525-.5H3.741a.513.513 0 0 0-.525.5V14c0 .276.235.5.525.5h1.811c.29 0 .525-.224.525-.5V4.5Zm-.381 14c.29 0 .524.224.524.5s-.235.5-.524.5H3.598a.513.513 0 0 1-.525-.5c0-.276.235-.5.525-.5h2.098ZM8.318 3c0-.552.47-1 1.049-1h4.195c.58 0 1.049.448 1.049 1v18c0 .552-.47 1-1.049 1H9.367c-.58 0-1.05-.448-1.05-1V3Zm4.577 10.5c0-.276-.235-.5-.525-.5h-1.812a.513.513 0 0 0-.524.5V19c0 .276.235.5.524.5h1.812c.29 0 .525-.224.525-.5v-5.5ZM12.37 4c.29 0 .525.224.525.5v3c0 .276-.235.5-.525.5h-1.812a.513.513 0 0 1-.524-.5v-3c0-.276.235-.5.524-.5h1.812Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e94f65fd37355fc155505b9d2ee0e992.svg";
export { ForwardRef as ReactComponent };